import _ from "lodash";
import {
  clearAuthSession,
  persistAuthSession,
  readAuthTokensFromResponse,
} from "services/auth-session.service";
import { LoginValueProps } from "types";
import networkService from "services/sub-services/network-service/network.service";
import authenticationUrls from "services/sub-services/user-auth-service/user-auth.urls";
import { PortalAccessProfile } from "types/api";

const loginService = async (
  formData: LoginValueProps,
): Promise<{
  accessToken: string;
  refreshToken: string | null;
  user: { role?: string; portal_access?: PortalAccessProfile | null; [key: string]: any };
}> => {
  const response = await networkService.post(authenticationUrls.sessionUrl(), {
    email: formData.username,
    password: formData.password,
  });

  const { accessToken, refreshToken } = readAuthTokensFromResponse(response);
  const user = _.get(response, "data.user", {});

  if (!accessToken) {
    throw new Error("No access token returned");
  }

  persistAuthSession({
    accessToken,
    refreshToken,
    role: user?.role || null,
    portalAccess: user?.portal_access || null,
  });

  return { accessToken, refreshToken, user };
};

const signOut = () => {
  clearAuthSession();
  window.location.reload();
};

export default {
  loginService,
  signOut,
};
